import { get, post, remove } from 'api';
import { LOAD_FAILED_ORDERS_PARAMS } from 'appConstants';

import {
  FAILED_ORDERS_LOADED,
  FAILED_ORDERS_SYNC_ERROR,
  FAILED_ORDER_REMOVED,
  FAILED_ORDER_REMOVE_ERROR,
  LOAD_FAILED_ORDERS,
  REMOVE_FAILED_ORDER,
  RESET_FAILED_ORDERS,
  SYNC_RESENDED_ORDER,
} from './actionTypes';

export const initialActionsState = {
  loadFailedOrders: () => {},
  resetFailedOrders: () => {},
  removeFailedOrder: () => {},
  resendFailedOrder: () => {},
  syncResentOrder: () => {},
};

export const getActions = (dispatch: {
  (value: { type: any; payload?: any }): void;
  (arg0: { type: string; payload?: any }): void;
}) => ({
  loadFailedOrders: async () => {
    dispatch({
      type: LOAD_FAILED_ORDERS,
    });

    const { data, error } = await get('/seed/orders', {
      params: {
        status: LOAD_FAILED_ORDERS_PARAMS.STATUS,
        limit: LOAD_FAILED_ORDERS_PARAMS.LIMIT,
      },
    });

    const payload = data || [];

    if (!error || payload) {
      dispatch({
        type: FAILED_ORDERS_LOADED,
        payload,
      });
    } else {
      dispatch({
        type: FAILED_ORDERS_SYNC_ERROR,
        payload: error,
      });
    }
  },
  removeFailedOrder: async (internalOrderId: string, onDone) => {
    dispatch({
      type: REMOVE_FAILED_ORDER,
    });

    const { error } = await remove(`/seed/orders/${internalOrderId}`);

    if (!error) {
      dispatch({
        type: FAILED_ORDER_REMOVED,
        payload: internalOrderId,
      });
    } else {
      dispatch({
        type: FAILED_ORDER_REMOVE_ERROR,
        payload: error,
      });
    }

    if (onDone) onDone(error);
  },
  syncResentOrder: async (
    orderId: string,
    publishStatus: string,
    publishDate: string,
    onDone?: (data?) => void,
  ) => {
    const { data, error } = await get(`/seed/orders/${orderId}`);

    if (
      data &&
      !error &&
      (data['publishStatus'] !== publishStatus || data['publishDate'] !== publishDate)
    ) {
      dispatch({
        type: SYNC_RESENDED_ORDER,
        payload: data,
      });
    }
    if (onDone) {
      onDone(data);
    }
  },
  resendFailedOrder: async (internalOrderId: string, onDone: (error) => void) => {
    const { error } = await post(`/seed/send-order/${internalOrderId}`, {});
    if (onDone) onDone(error);
  },
  resetFailedOrders: () =>
    dispatch({
      type: RESET_FAILED_ORDERS,
    }),
});
